import { useAppSelector } from '../../../ReduxToolkit/Hooks';
import { Col } from 'reactstrap';
import { PlaceOrder, Products, Subtotal, Total } from '../../../utils/Constant';
import { H4, LI, UL } from '../../../AbstractElements';
import { getallCardTotal } from '../../../Service/Ecommerce.service';
import { Link } from 'react-router-dom';
import CheckoutShipping from './CheckoutShipping';
import CheckPayment from './CheckPayment';
import { formatPrice } from '../../../utils/helper/helpers';

const ProductCheckout = () => {
  const { cart } = useAppSelector((state) => state.cartData);
  return (
    <div className='checkout'>
      <div className="checkout-details">
        <div className="order-box">
          <div className="title-box">
            <div className="checkbox-title">
              <H4>{Products} </H4>
              <span>{Total}</span>
            </div>
          </div>
          <UL className="qty simple-list">
            {cart.map((data, i) => (
              <LI key={i}>
                {data.libelle} × {data.total} <span>{formatPrice(data.prix_unitaire * data.total)}</span>
              </LI>
            ))}
          </UL>
          <UL className="sub-total simple-list">
            <LI>
              {Total} <span className="count">{formatPrice(getallCardTotal(cart))}</span>
            </LI>
          </UL>
          <div className="order-place">
            <Link className="btn btn-info" to={`${process.env.PUBLIC_URL}/ventes`} >
              <i className='fa fa-mail-reply'></i> Revenir sur les ventes
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ProductCheckout